/* ============================================================
 * df-cart-fly — la pieza vuela a la cesta al añadirla.
 *
 * Por qué existe: un añadir sin respuesta visual deja al cliente sin saber
 * si ha pasado algo, y la duda se resuelve abriendo el carrito — que es
 * justo sacarlo de la ficha. Esto responde en 700 ms sin moverlo de sitio.
 *
 * Cómo funciona:
 *   1. Al pulsar, se clona la foto del producto en un disco.
 *   2. El disco recorre un ARCO hasta la cesta (dos tramos con easings
 *      distintos: sube rápido y cae con peso, como algo que se lanza).
 *   3. Al llegar, la bolsa lo "recibe": el asa se levanta, la bolsa da un
 *      bote y la chapa del contador hace un pop.
 *
 * Respeta prefers-reduced-motion: sin vuelo, solo el pop de la chapa.
 * ============================================================ */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var flying = false;

  function cartEl() {
    return document.querySelector('.df-header__cart');
  }

  /* La foto que vuela: la del producto que se está añadiendo si se puede
     encontrar cerca del botón, y si no la de la ficha principal. */
  function sourceImage(btn) {
    var card = btn.closest('.df-addons__card, .df-rv__card, form, .df-pdp__grid');
    var img = card && card.querySelector('img');
    if (img && img.currentSrc) return img;
    var main = document.querySelector('.df-pdp__media img, .tee-slide--active img, .df-pdp__video-poster');
    return main && main.currentSrc ? main : null;
  }

  function bump(cart) {
    cart.classList.remove('is-receiving');
    // Reflow para poder relanzar la animación en adds seguidos
    void cart.offsetWidth;
    cart.classList.add('is-receiving');
    setTimeout(function () { cart.classList.remove('is-receiving'); }, 620);
  }

  function fly(btn) {
    var cart = cartEl();
    if (!cart) return;
    if (reduce || flying) { bump(cart); return; }

    var img = sourceImage(btn);
    var from = (img || btn).getBoundingClientRect();
    var to = cart.getBoundingClientRect();
    if (!from.width || !to.width) { bump(cart); return; }

    flying = true;

    var size = 54;
    var x0 = from.left + from.width / 2 - size / 2;
    var y0 = from.top + from.height / 2 - size / 2;
    var x1 = to.left + to.width / 2 - size / 2;
    var y1 = to.top + to.height / 2 - size / 2;

    var ghost = document.createElement('span');
    ghost.className = 'df-fly';
    ghost.style.cssText =
      'width:' + size + 'px;height:' + size + 'px;' +
      'transform:translate3d(' + x0 + 'px,' + y0 + 'px,0)';
    if (img) {
      var pic = document.createElement('img');
      pic.src = img.currentSrc || img.src;
      pic.alt = '';
      ghost.appendChild(pic);
    }
    document.body.appendChild(ghost);

    // Cumbre del arco: por encima del punto más alto de los dos extremos.
    var apexX = x0 + (x1 - x0) * 0.55;
    var apexY = Math.min(y0, y1) - Math.max(70, Math.abs(y1 - y0) * 0.28);

    var up = ghost.animate(
      [
        { transform: 'translate3d(' + x0 + 'px,' + y0 + 'px,0) scale(1) rotate(0deg)', opacity: 1 },
        { transform: 'translate3d(' + apexX + 'px,' + apexY + 'px,0) scale(.8) rotate(-8deg)', opacity: 1 }
      ],
      { duration: 300, easing: 'cubic-bezier(.22,.9,.36,1)', fill: 'forwards' }
    );

    up.onfinish = function () {
      var down = ghost.animate(
        [
          { transform: 'translate3d(' + apexX + 'px,' + apexY + 'px,0) scale(.8) rotate(-8deg)', opacity: 1 },
          { transform: 'translate3d(' + x1 + 'px,' + y1 + 'px,0) scale(.18) rotate(6deg)', opacity: .35 }
        ],
        // Cae acelerando: es lo que le da peso al gesto.
        { duration: 380, easing: 'cubic-bezier(.6,.02,.9,.5)', fill: 'forwards' }
      );
      down.onfinish = function () {
        ghost.remove();
        flying = false;
        bump(cart);
      };
    };
  }

  /* Un solo listener en el documento: cubre el CTA de la ficha, los
     complementos y cualquier formulario de /cart/add que aparezca después. */
  document.addEventListener(
    'click',
    function (e) {
      var btn = e.target.closest(
        '[data-df-addon-add], .df-pdp__cta, [data-df-pdp-stickycta] .df-pdp__stickycta-cta, form[action*="/cart/add"] [type="submit"]'
      );
      if (!btn || btn.disabled) return;
      // El vuelo es solo el acuse de recibo; quien añade de verdad es cada
      // sección. Si el add falla, la chapa no sube y se nota.
      fly(btn);
    },
    true
  );
})();
